import React from 'react';
import { LayoutItem } from 'react-grid-layout';
import {
  ILabelValuePanel,
  IEnergyConsumptionPanel,
} from '../../../../../../../../theme/ui/Dashboard/Dashboard.model';
import LabelValuePanel, {
  DefaultRightContainer,
} from '../../../../../../../../theme/ui/Dashboard/LabelValuePanel/LabelValuePanel';
import { useTranslation } from 'react-i18next';
import { EnergyConsumptionIcon } from '../../../../../../../../assets/dashboard';
import { Box, Paper, Typography } from '@mui/material';
import useConsumptionData from '../../../../../../../../redux/reports/hooks/useConsumptionData';
import { useUserSettingState } from '../../../../../../../../redux/user/UserSettingsAPI/hook/useUserSettingState';
import { InputSelectTimeFrame } from '../../shared/InputSelectTimeFrame';

export interface EnergyConsumptionPanelProps {
  panel: IEnergyConsumptionPanel;
  layout?: LayoutItem;
}

function EnergyConsumptionPanel(props: EnergyConsumptionPanelProps) {
  const { panel, layout } = props;
  const { t } = useTranslation();
  const scope = `${panel.typeRequest}:${
    panel.groupId ?? panel.workspaceId ?? '*'
  }`;

  const { data: timeValue, setData: setTimeValue } =
    useUserSettingState<string>(`energyConsumptionPanel:${scope}`, 'week');

  const { value, isLoading, error, errorNoSchedule } = useConsumptionData({
    groupId: panel.groupId,
    workspaceId: panel.workspaceId,
    typeRequest: panel.typeRequest,
    timeFrame: timeValue,
  });

  const labelValuePanel: ILabelValuePanel = {
    type: 'LABEL_VALUE',
    id: `energy_consumption`,
    title: panel.title,
    subtitle: panel.subtitle,
    icon: <EnergyConsumptionIcon height={'100%'} />, // height similar to other icons
    content: (
      <Box
        sx={{
          display: 'flex',
          px: 1,
          flexDirection: 'column',
          alignItems: 'center',
          height: '100%',
          gap: 1,
        }}
      >
        <InputSelectTimeFrame
          value={timeValue ?? ''}
          onChange={(value) => setTimeValue(value, true)}
        />
        <Paper
          elevation={8}
          sx={{
            height: '100%',
            width: '100%',
            boxShadow: 'none',
            borderRadius: '18px',
            backgroundColor: (theme) =>
              theme.palette.mode === 'dark'
                ? theme.palette.background.paper
                : theme.palette.background.default,
            overflow: 'hidden',
          }}
        >
          <DefaultRightContainer sx={{ minWidth: 'initial' }}>
            <Typography
              sx={{
                fontSize: '0.5em',
                fontWeight: 800,
                textAlign: 'center',
              }}
            >
              {value}
            </Typography>
          </DefaultRightContainer>
        </Paper>
      </Box>
    ),
    loading: isLoading,
    error: error
      ? t('dashboard.error.fetching')
      : errorNoSchedule
      ? t('dashboard.energy_consumption_flexeserve.error.no_schedule')
      : undefined,
  };
  return (
    <LabelValuePanel
      panel={labelValuePanel}
      layout={layout}
      PaperProps={{
        elevation: 0,
        sx: {
          backgroundColor: (theme) => 'unset',
          backgroundImage: 'none',
        },
      }}
    />
  );
}

export default EnergyConsumptionPanel;
